import Globelink from "../assets/images/GlobelinkLogo.png";
import Meta from "../assets/images/facebook.png";
import Instagram from "../assets/images/instagram.png";

const Footer = () => {
  return (
    <footer className="w-full bg-white text-gray-700 relative bottom-0">
      <div className="container mx-auto px-6 py-10">
        {/* Top Section */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-10 border-b border-gray-300 pb-10">
          {/* Logo Section */}
          <div className="flex flex-col items-center md:items-start">
            <img
              src={Globelink}
              alt="Globelink Logo"
              className="w-[104px] h-[114px] mb-4"
            />
            <p className="text-sm text-gray-600 text-center md:text-left">
              Globelink is your trusted HR placement partner.
            </p>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col items-center md:items-center">
            <h3 className="text-lg font-semibold text-[#012647] mb-3">
              Quick Links
            </h3>
            {[
              { name: "Home", link: "/" },
              { name: "About", link: "/about" },
              { name: "Services", link: "/services" },
              { name: "Contact", link: "/contact" },
            ].map((item, index) => (
              <a
                key={index}
                href={item.link}
                className="text-sm mb-2 transition-colors duration-200 hover:text-[#75000E]"
              >
                {item.name}
              </a>
            ))}
          </div>

          {/* Services */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="text-lg font-semibold text-[#012647] mb-3">
              Services
            </h3>
            {[
              { name: "Privacy", link: "/privacy" },
              { name: "Terms", link: "/terms" },
              { name: "Refund Policy", link: "/refundpolicy" },
              { name: "Register", link: "/register" },
            ].map((service, index) => (
              <a
                key={index}
                href={service.link}
                className="text-sm mb-2 transition-colors duration-200 hover:text-[#75000E]"
              >
                {service.name}
              </a>
            ))}
          </div>

          {/* Contact */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="text-lg font-semibold text-[#012647] mb-3">
              Contact
            </h3>
            <div className="flex space-x-4 mb-3">
              <a
                href="https://www.facebook.com/profile.php?id=61575205743103"
                className="transition-transform duration-200 hover:scale-110"
              >
                <img src={Meta} alt="Facebook" className="w-6 h-6" />
              </a>
              {/* <a
                href="https://x.com/i/flow/login"
                className="transition-transform duration-200 hover:scale-110"
              >
                <img src={Twitter} alt="Twitter" className="w-6 h-6" />
              </a> */}
              {/* <a
                href="https://www.google.com/"
                className="transition-transform duration-200 hover:scale-110"
              >
                <img src={Google} alt="Google" className="w-6 h-6" />
              </a> */}
              <a
                href="https://www.instagram.com/globelink.placement/"
                className="transition-transform duration-200 hover:scale-110"
              >
                <img src={Instagram} alt="Instagram" className="w-6 h-6" />
              </a>
            </div>
            <p className="text-sm">info@globelinkplacement.com</p>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-8 flex flex-col md:flex-row items-center justify-between text-gray-600 text-xs">
          <div className="flex flex-wrap gap-4 mb-4 md:mb-0">
            {[
              { text: "Privacy Policy", href: "/privacy" },
              { text: "Terms of Use", href: "/terms" },
              { text: "Refund Policy", href: "/refundpolicy" },
            ].map((link, index) => (
              <a
                key={index}
                href={link.href}
                className="font-semibold transition-colors duration-200 hover:text-[#75000E]"
              >
                {link.text}
              </a>
            ))}
          </div>
          <p className="text-center">
            © {new Date().getFullYear()} Globelink. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
